const emailMask = value => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,20})$/i;
  return emailRegex.test(value);
};

export default emailMask;